import { render, staticRenderFns } from "./eComplaintFileUpload.vue?vue&type=template&id=2c7dcafb"
import script from "./eComplaintFileUpload.vue?vue&type=script&lang=js"
export * from "./eComplaintFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports